import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconLayoutCollage = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M8.203 11.75h12.305V6.5c0-.688-.25-1.273-.75-1.758-.485-.5-1.07-.75-1.758-.75H8.203v7.758zm12.305 1.5h-3.211v7.758H18c.688 0 1.273-.242 1.758-.727.5-.5.75-1.093.75-1.781v-5.25zm-4.711 7.758V13.25H3.492v5.25c0 .688.242 1.281.727 1.781.5.485 1.093.727 1.781.727h9.797zM3.492 11.75h3.211V3.992H6c-.688 0-1.281.25-1.781.75A2.394 2.394 0 0 0 3.492 6.5v5.25zm-1.5 0V6.5c0-1.11.39-2.055 1.172-2.836C3.945 2.883 4.891 2.492 6 2.492h12c1.11 0 2.055.39 2.836 1.172.781.781 1.172 1.727 1.172 2.836v12c0 1.11-.39 2.055-1.172 2.836-.781.781-1.727 1.172-2.836 1.172H6c-1.11 0-2.055-.39-2.836-1.172-.781-.781-1.172-1.727-1.172-2.836v-6.75z" }),
});

export { IconLayoutCollage };
